<template>
  <div class="tiles__tile tiles__tile--ad" ref="root">
    <div class="tiles__inner">

      <div class="tiles__image-wrap">
        <template v-if="tile.type === 'ad'">
          <a :href="tile.url" target="_blank" rel="noopener noreferrer">
            <div class="tiles__image-picture">
              <div class="tiles__image-aspect" :class="[`tiles__image-aspect--${size}`]">
                <div class="tiles__image-aspect-inner" :data-track-banner="trackBannerJson">
                  <Image :image="tile.image[size] ?? null"/>
                </div>
              </div>
            </div>
          </a>
        </template>
        <template v-else>
          <img v-if="size === 'small'" class="tiles__image"
               width="455" height="340"
               :src="utils.placeholderUri(455, 340)">
          <img v-if="size === 'medium'" class="tiles__image"
               width="930" height="340"
               :src="utils.placeholderUri(930, 340)">
          <img v-if="size === 'large'" class="tiles__image"
               width="930" height="700"
               :src="utils.placeholderUri(930, 700)">
        </template>
      </div>
      <div class="tiles__text-wrap" v-if="tile.type === 'null-ad'">
        <span>Werbeplatz</span>
      </div>
    </div>
  </div>
</template>


<script setup>
import {ref, computed, onMounted} from "vue";
import utils from "../utils";
import Image from "./Image.vue";

const root = ref(null)

const props = defineProps({
  tile: /** @type {AdTile|NullAdTile} */ Object,
  size: /** @type {ImageSize} */ String,
})

const trackBannerJson = computed(() => {
  return JSON.stringify({
    uid: parseInt(props.tile.id.replace(/^ad-/, '')),
    name: props.tile.title,  // should be company name
    trackUri: props.tile.trackUri,
  })
})

onMounted(() => {
  // @todo: this causes retracking when the filter is cleared.
  window.observeTrackBanners(root.value)
})

</script>
